import React from 'react'

const Cp_linear = () => {
    return (
        <div className='container'>
            <h1>Linear Search</h1>
            <p><strong>Problem:</strong> Given an array arr[] of n elements, write a function to search a given
             element x in arr[].</p>
             <p><strong>Examples :</strong>&nbsp;&nbsp;</p>
             <div className='output'>
             Input : arr[] = &#123;10, 20, 80, 30, 60, 50,  <br />
                     110, 100, 130, 170&#125; <br />
          x = 110; <br />
Output : 6 <br />
Element x is present at index 6 <br />
 <br />
Input : arr[] = &#123;10, 20, 80, 30, 60, 50,  <br />
                     110, 100, 130, 170&#125; <br />
           x = 175; <br />
Output : -1 <br />
Element x is not present in arr[]. <br />
             </div>
             <p>A simple approach is to do a <strong>linear search</strong>, i.e&nbsp;&nbsp;</p>
             <ul>
                 <li>Start from the leftmost element of arr[] and one by one compare x with each element of arr[]</li>
                 <li>If x matches with an element, return the index.</li>
                 <li>If x doesn’t match with any of elements, return -1.</li>
            </ul>
            <div class="containers"> 
        <div class="line number1 index0 alt2"><code
                        class="comment">// C++ code to linearly search x in arr[]. If x</code></div>
        <div class="line number2 index1 alt1"><code
                        class="comment">// is present then return its location, otherwise</code></div>
        <div class="line number3 index2 alt2"><code class="comment">// return -1</code></div>
        <div class="line number4 index3 alt1">&nbsp;</div>
        <div class="line number5 index4 alt2"><code class="library">#include &lt;iostream&gt;</code></div>
        <div class="line number6 index5 alt1"><code class="keyword bold">using</code> <code
                        class="keyword bold">namespace</code> <code class="plain">std;</code></div>
        <div class="line number7 index6 alt2">&nbsp;</div>
        <div class="line number8 index7 alt1"><code class="keywords">int</code> <code
                        class="plain">search(</code><code class="keywords">int</code> <code
                        class="plain">arr[], </code><code class="keywords">int</code> <code
                        class="plain">n, </code><code class="keywords">int</code> <code class="plain">x)</code></div>
        <div class="line number9 index8 alt2"><code class="plain">&#123;</code></div>
        <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">int</code> <code class="plain">i;</code></div>
        <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword bold">for</code> <code class="plain">(i = 0; i &lt; n; i++)</code></div>
        <div class="line number12 index11 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword bold">if</code> <code class="plain">(arr[i] == x)</code></div>
        <div class="line number13 index12 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword bold">return</code> <code class="plain">i;</code></div>
        <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword bold">return</code> <code class="plain">-1;</code></div>
        <div class="line number15 index14 alt2"><code class="plain">&#125;</code></div>
        <div class="line number16 index15 alt1">&nbsp;</div>
        <div class="line number17 index16 alt2"><code class="comment">// Main function</code></div>
        <div class="line number18 index17 alt1"><code class="keywords">int</code> <code
                        class="plain">main(</code><code class="keyword bold">void</code><code class="plain">)</code>
        </div>
        <div class="line number19 index18 alt2"><code class="plain">&#123;</code></div>
        <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">int</code> <code class="plain">arr[] = &#123; 2, 3, 4, 10, 40 &#125;;</code></div>
        <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">int</code> <code class="plain">x = 10;</code></div>
        <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">int</code> <code class="plain">n = </code><code
                        class="keyword bold">sizeof</code><code class="plain">(arr) / </code><code
                        class="keyword bold">sizeof</code><code class="plain">(arr[0]);</code></div>
        <div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
        <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Function call</code></div>
        <div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">int</code> <code class="plain">result = search(arr, n, x);</code></div>
        <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">(result == -1)</code></div>
        <div class="line number27 index26 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">? cout &lt;&lt; </code><code
                        class="string">"Element is not present in array"</code></div>
        <div class="line number28 index27 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">: cout &lt;&lt; </code><code class="string">"Element is present at index "</code>
                <code class="plain">&lt;&lt; result;</code></div>
        <div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword bold">return</code> <code class="plain">0;</code></div>
        <div class="line number30 index29 alt1"><code class="plain">&#125;</code></div>
</div>
<div className='output'>
    <p><strong>Output</strong></p>
    Element is present at index 3
</div>
        </div>
    )
}

export default Cp_linear
